'use client'

import React from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const cards = [
	{
		title: 'Техническое сопровождение',
		description: 'Поддерживаем стабильную работу ваших ИТ-систем 24/7. Развиваем функционал, защищаем от угроз и оперативно решаем технические задачи любой сложности.',
		image: '/images/services/it-support-technical-support.svg'
	},
	{
		title: 'Технологическая экспертиза',
		description: 'Проводим аудит ИТ-систем, проектируем архитектуру и усиливаем вашу команду нашими экспертами. Помогаем достигать бизнес-целей с помощью технологий.',
		image: '/images/services/it-support-expertise.svg'
	},
	{
		title: 'Аутстаффинг',
		description: 'Предоставляем выделенных специалистов или целые команды. Это позволяет быстро расти и закрывать кадровые потребности без затрат на долгий поиск и найм.',
		image: '/images/services/it-support-outstaffing.svg'
	}
]

const ITSupport: React.FC = () => {
	const router = useRouter()
	const { openConsultationModal } = useModal()

	const handleCardClick = (title: string) => {
		if (title === 'Техническое сопровождение') {
			// Карточка "Техническое сопровождение" - переход на страницу support
			router.push('/services/support')
		} else if (title === 'Аутстаффинг') {
			router.push('/services/outstaffing')
		} else {
			// Остальные карточки - открытие модалки
			openConsultationModal()
		}
	}

	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Сопровождение и экспертиза
					</Typography>
					<Typography variant='h2' className={styles.title}>
						ИТ-сопровождение бизнеса
					</Typography>
				</div>
			</AnimatedSection>

			<div className={styles.cards}>
				{cards.map((card, idx) => (
					<AnimatedSection key={idx} animation="slideUp">
						<div className={styles.card}>
							<div className={styles.cardImage}>
								<Image
									src={card.image}
									alt={card.title}
									width={310}
									height={310}
									className={styles.image}
								/>
							</div>
							<div className={styles.cardContent}>
								<Typography variant='h3' className={styles.cardTitle}>
									{card.title}
								</Typography>
								<Typography variant='p1' color='description' className={styles.cardDescription}>
									{card.description}
								</Typography>
								<div className={styles.link} onClick={() => handleCardClick(card.title)}>
									<div className={styles.linkContent}>
										<span className={styles.linkText}>Подробнее</span>
										<div className={styles.linkIcon}>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
												<path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

ITSupport.displayName = 'ITSupport'

export default ITSupport